import { lazy } from 'react';

export const SuppliersPage = lazy(() => import('./SuppliersPage'));
export const SuppliersSettingsPage = lazy(() => import('./SuppliersSettingsPage'));
